<template>
  <div class="container">
    <div v-if="!doubleRoleComp">
      <h1
        style="
          font-weight: 600 !important;
          font-family: 'Merriweather', serif !important;
        "
        class="text-center h4"
      >
        Get paid to play with pets
      </h1>
      <div>
        <img
          src="https://www.dupaws.com/services/images/site/become-a-sitter.jpg"
          class="img img-responsive"
        />
      </div>

      <br />

      <h1
        style="
          font-weight: 600 !important;
          font-family: 'Merriweather', serif !important;
        "
        class="text-center h4"
      >
        100% commission free
      </h1>
      <hr style="margin-top: 0px" />
      <div>
        <div class="col-sm-5 col-sm-offset-2 col-xs-12">
          <p>
            <i style="color: #00bd70" class="fa fa-check"></i> Set your own
            price rates
          </p>
          <p>
            <i style="color: #00bd70" class="fa fa-check"></i> Set your own
            schedule and availability
          </p>
        </div>
        <div class="col-sm-5 col-xs-12">
          <p>
            <i style="color: #00bd70" class="fa fa-check"></i> Get paid 100%
            commission free.
          </p>
          <p>
            <i style="color: #00bd70" class="fa fa-check"></i> Only accept pets
            that match your preferrence.
          </p>
        </div>
      </div>
      <br />

      <!--  <div class="col-xs-12"> //mobile
    <br>            
                <h2 class="text-center"> pet sitters feedback:</h2>
                <hr>
                <div class="carousel" style="background:" id="fade-quote-carousel" data-ride="carousel" data-interval="3000">
                      <div class="quote"><i class="fa fa-quote-left fa-2x"></i></div>
                        <div class="item">
                                    <div class="profile-circle"></div>
                          <blockquote style="overflow: hidden;background: aliceblue; border-left:0px;border-radius: 8px;">
                            <p>I have my first client in my house, a very nice dog and easy to take care. I know not all the animals will be easy and nice like this one but still I am very happy.</p>
                               <div style="margin-right:50px;" class="pull-right">
                          <p style="margin-bottom:10px;"><strong>Magda C</strong></p>
                          </div>
                          </blockquote>	
                       
                        </div>
                        
              </div>
      
    </div>-->
      <div class="col-xs-12">
        <br />
        <h1
          style="
            font-weight: 600 !important;
            font-family: 'Merriweather', serif !important;
          "
          class="text-center h4"
        >
          How this work
        </h1>
        <hr style="margin-top: 0px" />
        <p class="">
          It takes around 3 to 5 minutes to create a profile, once completed and
          approved pet owners will be able to directly contact and book your
          services.
        </p>

        <!--<hr>-->
        <!--    
    <p class="">
      Creating a profile is easy, it takes around 10 minutes to be completed, we review each and every profile before publishing it to ensure all the details are filled, once completed you will get an SMS and email notification.
    </p>
    -->
      </div>
      <div v-if="!checkUserComp">
        <div class="col-xs-12 col-sm-4 col-sm-offset-4">
          <button
            style="font-family: 'Merriweather', serif !important"
            class="btn btn-success btn-lg btn-block"
            @click="goSitterSignup()"
          >
            Get Started
          </button>
          <!--<h4 class="text-center">or</h4>-->
          <br />
        </div>
        <!--
        <div  class="col-xs-12 col-sm-4 col-sm-offset-4">
         <p class="text-center">Have a look at our lovely pet sitters</p>
          <button style="font-size:larger; padding:0.3em" class="btn btn-info btn-block btn-title-big"  @click="goFindSitters()">Find Sitters</button>
        </div>-->
      </div>
      <div v-if="checkUserComp" class="col-xs-12 col-sm-4 col-sm-offset-4">
        <br />
        <button
          class="btn btn-info btn-block btn-title"
          @click="confirmSwitchAccount()"
        >
          Switch Account
        </button>
      </div>
    </div>
    <div v-else>
      <h3 class="text-center">
        Your account already registered as a sitter, go to
        <a href="/account"><strong>account</strong></a> to switch your role
      </h3>
    </div>
  </div>
</template>

<script>
import store from "../../data/store";
import auth from "../../auth/index";

export default {
  data() {
    return {
      title: "Become a Pet Sitter on Dupaws",
    };
  },
  methods: {
    goSitterSignup: function () {
      this.$router.push({ path: "/sitter-signup" });
    },
    goFindSitters: function () {
      this.$router.push({ path: "/findsitters" });
    },
    confirmSwitchAccount() {
      var self = this;
      swal(
        {
          title: "Switch Account Confirmation",
          text:
            "You are currently logged in as " +
            self.compUserRole +
            " if you click yes your account type will be changed and you will be logged out and prompted to login again, you can revert back to " +
            self.compUserRole +
            " anytime",
          type: "info",
          showCancelButton: true,
          confirmButtonClass: "btn-success",
          confirmButtonText: "Yes, switch account",
          closeOnConfirm: true,
          html: true,
        },
        function () {
          self.switchAccount();
        }
      );
    },
    switchAccount() {
      var self = this;
      $.ajax({
        type: "GET",
        url:
          "https://www.dupaws.com/services/api/account/SwitchRole/" +
          self.countryDataComp.CountryId,
        contentType: "application/json; charset=utf-8",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        success: function (data) {
          self.alert = data;
          auth.logout();
          self.$router.push({ path: "/login", query: { switch: "yes" } });
          // router.go({path: '/login', query: {switch: 'yes'}}) //workaround for refreshing the page and keeping path at /login.. dirty stuff...
        },
        error: function () {
          try {
            self.error = "Failed switching account";
          } catch (e) {
            self.error =
              "Oops we are having problem logging to the server, please try again in a moment..";
          }
        },
      });
    },
  },
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title,
      };
    },
    meta: [
      { name: "application-name", content: "Dupaws.com Pet Sitting" },
      {
        name: "description",
        content: "Become a Cat or Dog boarding member",
        id: "desc",
      },
      { property: "fb:app_id", content: "279352372578608" },
      {
        property: "og:title",
        content: "Join Dupaws and become a Cat or Dog boarding member",
      },
      { property: "og:url", content: "https://www.dupaws.com/become-a-sitter" },
      {
        property: "og:image",
        content:
          "https://www.dupaws.com/services/images/site/become-a-sitter.jpg",
      },
      { property: "og:type", content: "website" },
      { property: "fb:admins", content: "636428053" },
      { property: "fb:pages", content: "1623158747696830" },
    ],
    link: [
      {
        rel: "canonical",
        href: "https://www.dupaws.com/become-a-sitter",
        id: "canonical",
      },
    ],
  },

  updated() {
    this.$ga.page(this.$router);
    //  $zopim(function (){
    //     $zopim.livechat.sendVisitorPath();
    // });
  },
  computed: {
    doubleRoleComp: function () {
      if (localStorage.getItem("doubleRole") == "True") return true;
      else return false;
    },
    checkUserComp: function () {
      return store.getters.authenticated;
    },
    countryDataComp: function () {
      return store.getters.CountryData;
    },
  },
};
</script>

<style scoped>
.img-responsive {
  margin: 0 auto;
}

.btn-title-big {
  font-size: 28px !important;

  font-family: "Yanone Kaffeesatz", sans-serif;
}
</style>



// WEBPACK FOOTER //
// BecomeSitter.vue?3001f5e2